import { amber, deepOrange, deepPurple, green, grey, red } from '@mui/material/colors';
import moment from 'moment';

moment.updateLocale('en', {
  week: {
    dow: 1, // Set Monday as the first day of the week (1 = Monday, 0 = Sunday)
  },
});

export const priorities = ['None', 'Low', 'Medium', 'High', 'Critical'];

export const priorityColors = {
  None: grey[400],
  Low: green[500],
  Medium: amber[500],
  High: deepOrange[500],
  Critical: deepPurple[500],
};

export const statusColors = {
  Working: { background: '#0070c0', font: 'white' },
  Complete: { background: '#00b050', font: 'white' },
  Held: { background: '#fcc000', font: 'white' },
  Started: { background: deepPurple[500], font: 'white' },
  'Not Started': { background: '#bdbdbd', font: 'black' },
};

export const dueTimes = {
  yesterday: 'Due this week',
  thisWeek: 'Due this Week',
  today: 'Today',
  tomorrow: 'Tomorrow',
  thisWeek: 'This week',
  nextWeek: 'Next week',
  lastWeek: 'Last week',
};

export const disabledTypes = ['process_step', 'approval', 'form_entry', 'dataRequest', 'ru'];

const getDateFormat = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
const getTodayDate = () => {
  const today = new Date();
  return getDateFormat(today);
};

export const getThisWeekDate = (startDateStr) => {
  const startDate = new Date(startDateStr);
  const dayOfWeek = startDate.getDay();
  const daysRemaining = 6 - dayOfWeek;

  // Calculate the start date of the week
  const startDateOfWeek = new Date(startDate);
  startDateOfWeek.setDate(startDate.getDate() - dayOfWeek);

  // Calculate the end date of the week
  const endDateOfWeek = new Date(startDate);
  endDateOfWeek.setDate(startDate.getDate() + daysRemaining);

  return {
    start: getDateFormat(startDateOfWeek),
    end: getDateFormat(endDateOfWeek),
  };
};

function getNextWeekDates() {
  const today = new Date();
  const currentDayOfWeek = today.getDay();
  const daysUntilNextWeek = 7 - currentDayOfWeek;
  const startDate = new Date(today);
  startDate.setDate(today.getDate() + daysUntilNextWeek);
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);

  const startDateFormat = getDateFormat(startDate);
  const endDateFormat = getDateFormat(endDate);

  return { start: startDateFormat, end: endDateFormat };
}
function getNextDayDate(dateStr) {
  const currentDate = new Date(dateStr);
  const nextDate = new Date(currentDate);
  nextDate.setDate(currentDate.getDate() + 1);
  return getDateFormat(nextDate);
}
function getPrevDayDate(dateStr) {
  const currentDate = new Date(dateStr);
  const prevDate = new Date(currentDate);
  prevDate.setDate(currentDate.getDate() - 1);
  return getDateFormat(prevDate);
}
const currentDate = new Date();

export const dueDateFilters = {
  isNotEmpty: {
    operator: 'isNotEmpty',
    value: '',
  },
  noDueDate: {
    operator: 'isEmpty',
    value: '',
  },
  overdue: {
    operator: 'onOrBefore',
    value: getPrevDayDate(currentDate),
  },
  today: {
    operator: 'between',
    value: [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  },
  thisWeek: {
    operator: 'between',
    value: [moment().startOf('week').toDate(), moment().endOf('week').toDate()],
  },
  nextWeek: {
    operator: 'between',
    value: [moment().add(1, 'week').startOf('week').toDate(), moment().add(1, 'week').endOf('week').toDate()],
  },
  later: {
    operator: 'onOrAfter',
    value: getNextDayDate(getNextWeekDates().end),
  },
};

export const completedDateFilters = {
  today: {
    operator: 'between',
    value: [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  },
  thisWeek: {
    operator: 'between',
    value: [moment().startOf('week').toDate(), moment().endOf('week').toDate()],
  },
  lastWeek: {
    operator: 'between',
    value: [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
  },
};

export function convertToTitleCase(str) {
  var words = str.match(/[A-Za-z][a-z]*/g) || [];
  return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export const filterFields = {
  priority: 'priority',
  title: 'title',
  created_by: 'created_by',
  type: 'type',
  dueAt: 'dueAt',
  progress: 'progress',
};
